export type NavigationItem = {
  label: string;
  path: string;
  initialType?: "recent" | "my" | "interest";
  logout?: boolean;
};
export type NavigationGroup = {
  id: string;
  label: string;
  items: NavigationItem[];
};
export const compactNavigationQuery =
  "(max-width: 900px), (max-aspect-ratio: 1/1)";

export function navigationGroups(
  signedIn: boolean,
  admin: boolean,
): NavigationGroup[] {
  return [
    {
      id: "facts",
      label: "팩트·토론",
      items: [
        { label: "전체 Fact", path: "/", initialType: "recent" },
        ...(signedIn
          ? [
              { label: "나의 Fact", path: "/", initialType: "my" as const },
              {
                label: "관심 Fact",
                path: "/",
                initialType: "interest" as const,
              },
            ]
          : []),
        { label: "자유게시판", path: "/freeboard" },
      ],
    },
    {
      id: "markets",
      label: "예측시장",
      items: [
        { label: "시장 목록", path: "/markets" },
        ...(signedIn ? [
          { label: "나의 예측", path: "/markets/me" },
          { label: "나의예측공유", path: "/portfolio/manage" },
        ] : []),
        { label: "예측 랭킹", path: "/markets/ranking" },
      ],
    },
    {
      id: "help",
      label: "이용안내",
      items: [
        { label: "공지사항", path: "/notices" },
        { label: "FactWeb 소개", path: "/about" },
      ],
    },
    ...(signedIn
      ? [
          {
            id: "account",
            label: "내 계정",
            items: [
              { label: "나의 정보", path: "/myinfo" },
              ...(admin ? [{ label: "관리자 페이지", path: "/admin" }] : []),
              { label: "로그아웃", path: "/", logout: true },
            ],
          },
        ]
      : []),
  ];
}

export function activeNavigationGroup(path: string) {
  if (path === "/markets" || path.startsWith("/markets/") || path.startsWith("/portfolio/")) return "markets";
  if (path === "/admin" || path.startsWith("/admin/") || path === "/myinfo")
    return "account";
  if (path === "/about" || path === "/notices" || path.startsWith("/notices/"))
    return "help";
  return "facts";
}

export function navigationItemActive(
  item: NavigationItem,
  pathname: string,
  state: any,
) {
  if (item.logout) return false;
  if (item.initialType)
    return (
      pathname === "/" && (state?.initialType || "recent") === item.initialType
    );
  if (item.path === "/markets")
    return pathname === "/markets" || /^\/markets\/\d+$/.test(pathname);
  return pathname === item.path || pathname.startsWith(item.path + "/");
}
